import React, { Fragment, useContext, useEffect, useState } from 'react';

import Spacer from 'components/spacer';
import Card from 'components/card';
import Hr from 'components/hr';
import Button from 'components/button';

import If from 'conditionals/if';

import Edit from 'assets/img/edit.svg';
import Cancel from 'assets/img/cancel.svg';
import GoogleDrive from 'assets/img/logo-gdrive.svg';
import Dropbox from 'assets/img/dropbox.svg';
import Frequent from 'assets/img/frequent.svg';
import Notification from 'assets/img/notification.svg';

import LocaleContext from 'contexts/locale-context';

import formatPrice from 'helpers/format-price';
import doScrolling from 'helpers/do-scrolling'

import withFeatures from 'hoc/withFeatures';
import withPayment from 'hoc/withPayment';

import { FEATURES } from 'constants/index';

import './index.css';

const EXPORT_TO_GOOGLE = FEATURES.EXPORT_TO_GOOGLE_DRIVE;
const EXPORT_TO_DROPBOX = FEATURES.EXPORT_TO_DROPBOX;
const EXTEND_EXPIRY = FEATURES.EXTEND_EXPIRY;
const DOWNLOAD_NOTIFICATIONS = FEATURES.DOWNLOAD_NOTIFICATIONS;


const Features = ({ featuresBuilder, openPayment, features: _features, transferId, password = null}) => {
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [features, setFeatures] = useState([]);
  const [featuresButtons, setFeaturesButtons] = useState([]);
  const { translations } = useContext(LocaleContext);
  const jsTranslations = translations.js;
  const [selected, setSelected] = useState({});
  const [blinkFeature, setBlinkFeature] = useState(null);
  

  const selections = Object.values(selected).sort(function (a, b) {
    return b.info.timestamp - a.info.timestamp;
  });;

  const hasSelections = selections.length > 0;

  const getSum = (selecteds = {}) => {
    const features = Object.values(selecteds);
  
    let total = 0;
  
    features.forEach(value => {
      total += value.price_usd;
    });
  
    return total;
  };

  const prepareFeatures = (features = []) => {
    return features.map(feature => {
      feature.payload = {};

      if (feature.name === EXPORT_TO_DROPBOX) {
        feature.editFunc = onPickerEdit(EXPORT_TO_DROPBOX)
      } else if (feature.name === EXPORT_TO_GOOGLE) {
        feature.editFunc = onPickerEdit(EXPORT_TO_GOOGLE)
      }
      return feature;
    })
  }

  const onPicker = (storageFeatureId) => ({ payload = {}, info = {} }) => {
    if (setSelected && setFeatures) {
      setFeatures(features => {
        const feat = features.filter(savedFeature => savedFeature.name === storageFeatureId)[0];

        if (feat) {
          feat.payload = payload
          feat.info = info;
  
          setSelected(selecteds => {
            selecteds[info.generatedId] = {...feat};
            return {...selecteds};
          })

          setTimeout(() => {
            doScrolling(`#${info.generatedId}`, 1000, '#features__selections')
            .then(() => blinkSelections(info.generatedId))

          }, 200)
        }
        return features;
      })
    }
  }

  const blinkSelections = (id) => {
    setBlinkFeature(id);
    setTimeout(() => {
      setBlinkFeature(null);
    }, 1000)
  }

  const prepareFeaturesButtons = (features = []) => {
    const feats = features.map(feature => {
      const val = {};

      if (feature.name === EXPORT_TO_DROPBOX && featuresBuilder[EXPORT_TO_DROPBOX]) {
        val.name = EXPORT_TO_DROPBOX;
        val.title = jsTranslations.export_to_dropbox;
        val.icon = Dropbox;
        val.onClick = onPickerClicked(EXPORT_TO_DROPBOX)
      } else if (feature.name === EXPORT_TO_GOOGLE && featuresBuilder[EXPORT_TO_GOOGLE]) {
        val.name = EXPORT_TO_GOOGLE;
        val.title = jsTranslations.export_to_google_drive;
        val.icon = GoogleDrive;
        val.onClick = onPickerClicked(EXPORT_TO_GOOGLE)
      } else if (feature.name === EXTEND_EXPIRY && featuresBuilder[EXTEND_EXPIRY]) {
        val.name = EXTEND_EXPIRY;
        val.title = jsTranslations.extend_link;
        val.icon = Frequent;
        val.onClick = onPickerClicked(EXTEND_EXPIRY)
      } else if (feature.name === DOWNLOAD_NOTIFICATIONS && featuresBuilder[DOWNLOAD_NOTIFICATIONS]) {
        val.name = DOWNLOAD_NOTIFICATIONS;
        val.title = jsTranslations.download_notification;
        val.icon = Notification;
        val.onClick = onPickerClicked(DOWNLOAD_NOTIFICATIONS)
      }
      return val;
    })

    /**
     * This removes any feature that wasn't prepared above
     */
    return feats.filter(feat => !!feat.name);
  }

  const onPickerEdit = featureName => async (info) => {
    onPicker(featureName)(
      await featuresBuilder[featureName](info)
    )
  }

  const onPickerClicked = featureName => async () => {
    onPicker(featureName)(
      await featuresBuilder[featureName](selected[featureName])
    )
  }

  const onPay = async () => {
    setPaymentLoading(true);

    try {
      await openPayment({ selected, transferId, password })
      clearSelections()
    } catch(e) {}

    setPaymentLoading(false);
  }

  const clearSelections = () => {
    setSelected({});
  }

  useEffect(() => {
    setFeatures(prepareFeatures(_features));
    setFeaturesButtons(prepareFeaturesButtons(_features))
  }, [_features]);

  if (!transferId) return null;

  return (
    <div className='features__container'>
      <Spacer size='l' />
      <div className={`features ${!hasSelections ? 'features--centered' : ''}`}>
        <h3 className='features__features__title text-center'>{jsTranslations.tryout_extras}</h3>
        <Spacer size='l' />
        <div className='features__inner-container'>
          <div className={`features__features`}>
            <div>
              {featuresButtons.map((featureButton, idx) => {
                return (
                  <Fragment key={idx}>
                    <Card
                      elevation={1}
                      interactive
                      onClick={featureButton.onClick}
                      className='picker-button'
                    >
                      <img src={featureButton.icon} />
                      <p>{featureButton.title}</p>
                    </Card>
                  </Fragment>
                );
              })}
            </div>
          </div>
          <If condition={hasSelections}>
            <div className='features__features__payment'>
              <div className='flex row space-between'>
            <h3 className='mgn-0'>{selections.length} {jsTranslations.extras}</h3>
                <Button className='features__features__payment__clear' btnType='warn' onClick={clearSelections}>
                  {jsTranslations.clear}
                </Button>
              </div>
              <Spacer size='m' />
              <div id='features__selections' className='features__selections'>
                <If condition={hasSelections}>
                  {selections.map((selection, idx) => {
                    return (
                      <Fragment key={idx}>
                        <Spacer size='s' />
                        <div id={selection.info.generatedId} className={`features__features__payment-container flex row ${blinkFeature === selection.info.generatedId ? 'features__features__selections--blink' : ''}`}>
                          <div className='info'>
                            <h5>{selection.info.title}</h5>
                            <p>{selection.info.description}</p>
                          </div>
                          <div className='payment'>
                            <p>{formatPrice(selection.price_usd)}</p>
                            <div>
                              <img
                                alt='times icon'
                                src={Cancel}
                                onClick={() => {
                                  setSelected(selecteds=> {
                                    delete selecteds[selection.info.generatedId];
                                    return { ...selecteds };
                                  })
                                }}
                              />
                              <If condition={selection.editFunc}>
                                <img
                                  alt='edit icon'
                                  onClick={() => selection.editFunc(selection.info)}
                                  src={Edit}
                                />
                              </If>
                            </div>
                          </div>
                        </div>
                        <Spacer size='s' />
                        <Hr />
                      </Fragment>
                    )
                  })}
                </If>
              </div>
              <Spacer size='s' />
              <Button
                onClick={onPay}
                loading={paymentLoading}
              >
                {jsTranslations.pay} {formatPrice(getSum(selected))}
              </Button>
            </div>
          </If>
        </div>
      </div>
    </div>
  );
}

Features.defaultProps = {
  features: []
}

export default withFeatures()(withPayment()(Features));